import { render, staticRenderFns } from "./Usermanger.vue?vue&type=template&id=1202f164&scoped=true&lang=true&"
import script from "./Usermanger.vue?vue&type=script&lang=js&"
export * from "./Usermanger.vue?vue&type=script&lang=js&"
import style0 from "./Usermanger.vue?vue&type=style&index=0&id=1202f164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1202f164",
  null
  
)

export default component.exports